import React from "react";
import { Form, Formik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import Image from "../components/form-components/Image";
import Fields from "../components/form-components/Fields";
import Button from "../components/form-components/Button";

import { forgotPasswordLink } from "../features/auth/forget-password/forgotPasswordSlice";

import logo from "../assets/images/DocoMatic_beta.svg";
import Yup from "../validations/validationsLib";
import { OK } from "../constants/statusCode";
import { showError, showSuccess } from "../utils/messageHelper";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <>
      <Formik
        initialValues={{
          email: "",
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .required("Email is required")
            .email("Please Enter valid Email"),
        })}
        onSubmit={async (values) => {
          const { payload } = await dispatch(forgotPasswordLink(values));
          if (payload.status === OK) {
            showSuccess(payload.data.responseMessage);
            navigate("/login");
          } else {
            showError(payload?.response?.data?.responseMessage);
          }
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <Form>
            <div className="form-pages d-flex align-items-center">
              <div className="form-box">
                <span className="logo text-center">
                  <Image src={logo} alt="" />
                </span>
                <h1>Forgot Password</h1>
                <p className="forgot-note mb-1">
                  Please enter your registered email to receive password reset
                  instructions.
                </p>
                <div className="form-group">
                  <Fields
                    type="email"
                    placeholder="Email"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="email"
                    value={values.email}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <Button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 mt-1"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    Send Link
                  </Button>
                </div>
                <h4>
                  Back to{" "}
                  <Link to="/login" className="form-link">
                    Sign In
                  </Link>
                </h4>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
